import React, { Component } from 'react'
import { Popup } from 'devextreme-react/popup'
import Form from 'devextreme-react/form'
import { months, participants } from 'dataSource/lookup'
import httpRequest from 'plugin/httprequest'
import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid'

class ModalRiwayatIuranBulanan extends Component {
  constructor(props) {
    super(props)

    this.state = {
      popupVisible: false,
      dataParent: {},
    }

    this.show = this.show.bind(this)
    this.hide = this.hide.bind(this)

    this.PopupRef = React.createRef()
    this.formRiwayatIuranBulanan = React.createRef()
    this.showModalFormPembayaranRef = React.createRef()
    this.dataGridRef = React.createRef()

    this.formItems = [
      {
        itemType: 'group',
        caption: 'Periode Iuran',
        cssClass: 'group-radius',
        items: [
          {
            dataField: 'tahun',
            label: {
              text: 'Tahun',
            },
            editorType: 'dxNumberBox',
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
            },
          },
          {
            dataField: 'bulan',
            label: {
              text: 'Bulan',
            },
            editorType: 'dxSelectBox',
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              dataSource: months(),
              valueExpr: 'id',
              displayExpr: 'value',
              searchEnabled: true,
              deferRendering: false,
            },
          },
          {
            dataField: 'pesertaAmount',
            label: {
              text: 'Jumlah peserta',
            },
            editorType: 'dxNumberBox',
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
            },
          },
          {
            dataField: 'iuranTotal',
            label: {
              text: 'Total Iuran',
            },
            editorType: 'dxNumberBox',
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              format: '#,##0.00',
            },
          },
        ],
      },
      {
        itemType: 'group',
        caption: 'Informasi Participant',
        cssClass: 'group-radius',
        items: [
          {
            dataField: 'participantCode',
            label: {
              text: 'Kode Participant',
            },
            editorType: 'dxSelectBox',
            editorOptions: {
              elementAttr: { class: 'bd-input-popup-disabled-dapen-default' },
              dataSource: participants(this.props.store),
              valueExpr: 'id',
              displayExpr: 'participantCode',
              placeholder: 'Kode Participant',
              deferRendering: false,
            },
          },
          {
            dataField: 'participantName',
            label: {
              text: 'Nama Participant',
            },
            editorType: 'dxSelectBox',
            editorOptions: {
              elementAttr: {
                class: 'bd-input-popup-disabled-dapen-default',
                style: 'margin-bottom: 5.5rem !important',
              },
              dataSource: participants(this.props.store),
              valueExpr: 'id',
              displayExpr: 'participantName',
              placeholder: 'Kode Participant',
              deferRendering: false,
            },
          },
        ],
      },
    ]

    this.columns = this.columns = [
      {
        dataField: 'rowNumber',
        caption: 'No.',
        cellRender: (data) => {
          return data.rowIndex + 1
        },
      },
      {
        dataField: 'participantId',
        caption: 'Pemberi Kerja',
        lookup: {
          dataSource: participants(this.props.store),
          valueExpr: 'id',
          displayExpr: 'participantName',
        },
      },
      {
        dataField: 'productName',
        caption: 'Produk',
      },
      {
        dataField: 'fullName',
        caption: 'Nama Lengkap',
      },
      {
        dataField: 'nik',
        caption: 'NIK',
      },
      {
        dataField: 'iuranPeserta',
        caption: 'Iuran Normal Peserta  ',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'iuranPk',
        caption: 'Iuran Normal PK',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
      {
        dataField: 'iuranLain',
        caption: 'Iuran Sukarela',
        dataType: 'number',
        format: '#,##0.00',
        alignment: 'right',
      },
    ]
  }

  show() {
    this.setState({
      popupVisible: true,
    })
  }

  retrieveData = async (data) => {
    let fetchForParent = await httpRequest(
      process.env.REACT_APP_BACKEND_CORE,
      this.props.store,
      `participant-iuran-uploads/summary/${data.id}`,
      'GET'
    )
    this.setState({
      dataParent: {
        bulan: fetchForParent.bulan,
        tahun: fetchForParent.tahun,
        pesertaAmount: fetchForParent.pesertaAmount,
        iuranTotal: fetchForParent.iuranTotal,
        participantCode: this.props.store.getState().sessionUser.participantId,
        participantName: this.props.store.getState().sessionUser.participantId,
        uploadFileId: data.id,
      },
    })
  }

  hide = async (e) => {
    this.setState({
      popupVisible: false,
      dataParent: {},
    })
  }

  renderElement = () => {
    return (
      <div>
        <Form
          ref={this.formRiwayatIuranBulanan}
          colCount={2}
          id={'formRiwayatIuranBulanan'}
          formData={this.state.dataParent}
          items={this.formItems}
          labelLocation="left"
          readOnly={true}
        />
        <div className="row">
          <div className="col-12">
            <DevExpressDataGrid
              ref={this.dataGridRef}
              loadAPI={`participant-iuran-upload-detils/summary?uploadId.equals=${this.state.dataParent.uploadFileId}`}
              insertAPI="-"
              updateAPI="-"
              deleteAPI="-"
              backendserver={process.env.REACT_APP_BACKEND_CORE}
              useArraySource={false}
              ArraySourceData={''}
              allowAdding={false}
              allowDeleting={false}
              allowUpdating={false}
              exportExcel={false}
              exportFileName={'Daftar-Iuran'}
              allowExportSelectedData={true}
              showBorders={true}
              paging={true}
              defaultPageSize={10}
              //bagian konfigurasi popup saat insert dan edit record
              popupTitle={'Daftar Iuran'}
              popupWidth={700} //masukan dalam ukuran pixel
              popupHeight={500} //masukkan dalam ukuran pixel
              popupFormLabelLocation="left" //accepted value = top, left, right
              popupFormMinColWidth={300} // minimum lebar kolom
              popupFormColCount={3} //jumlah kolom pada form
              //akhir bagian konfigurasi popup

              ColumnChooser={true} // set false agar kolom tidak dapat di pindah pindah
              ColumnFixing={true} // set false agar kolom tidak dapat di freeze
              FilterRow={true} // set false untuk mematikan fitur filter
              ColumnConfiguration={this.columns} // taruh konfigurasi kolom disini
              onToolbarPreparing={this.onToolbarPreparing}
              // onToolbarPreparing={this.onToolbarPreparing}

              height="40vh"
              //contoh konfigurasi kolom
              //this.columns = [{
              //    dataField: 'kolom1',
              //    caption: 'Ini Kolom 1'
              //}, {
              //    dataField: 'kolom2',
              //    caption: 'Ini Kolom 2'
              //}]
              // detail konfigurasi dapat dilihat di https://js.devexpress.com/Documentation/ApiReference/UI_Widgets/dxDataGrid/Configuration/columns/

              store={this.props.store} // jangan di edit edit
            />
          </div>
        </div>
      </div>
    )
  }

  render() {
    let elem = this.state.popupVisible && this.renderElement()
    return (
      <React.Fragment>
        <Popup
          className={'popup'}
          visible={this.state.popupVisible}
          onHiding={this.hide}
          dragEnabled={true}
          showTitle={true}
          title={`Form Riwayat Iuran Bulanan`}
          width={'1000px'}
          height="auto"
          ref={this.PopupRef}
          toolbarItems={this.popupToolbarItem}
        >
          <div>{elem}</div>
        </Popup>
      </React.Fragment>
    )
  }
}

export default ModalRiwayatIuranBulanan
